export default "__VITE_ASSET__93456e61__"